<template>
    <div class="dashboard">
        <div class="chart-wrapper">
            <div class="container chart-border">
                <div class="chartPlaceholder">
                    <div class="logo">
                        <img src="../assets/img/logo.png" />
                    </div>
                    {{ $t("Page not found") }}
                    <button @click="$router.push('/')" class="crancy-btn crancy-sbcolor">{{ $t("Home") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageNotFoundView",
    created() {
        window.scrollTo(0, 0);
    },
};
</script>

<style scoped>
@media (max-width: 1199px) {
    .box {
        width: auto !important;
    }

    .placeForIcon {
        display: none !important;
        border: 3px solid red;
    }
}
.logo{
    height: 800px;
    width: 800px;
}
.img{
    height: 100%!important;
    width: 100%!important;
}
.crancy-btn{
    margin-top: 20px;
}
.chartPlaceholder {
    height: 400px;
    background-color: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 100px;
    font-size: 28px;
    flex-direction: column;
    gap: 20px;
}

.btn-primary {
    color: black;
    font-weight: 500;
    background-color: rgba(255, 153, 0, 0.322);
    border-color: rgba(255, 255, 255, 0.35);
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}

.btn-primary:hover {
    background-color: #f90 !important;
    transition: 0.4s;
    color: white
}

.dashboard {
    padding-top: 100px;
    background-color: #6498d0;
    height: 120vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    min-height: 1vh;
}

.whatIs {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.number {
    display: flex;
    justify-content: center;
    align-items: center;
}

.details {
    background-color: #e9ecef;
    border-radius: 10px;
    padding-bottom: 60px;
    padding-top: 20px;
    padding-left: 30px;
    padding-right: 30px;
    min-width: 800px;
}

.siteName {
    margin: 40px 0px;
}

h4 {
    font-weight: 500;
    font-size: 25px;
}

.box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 340px;
    height: 180px;
    border-radius: 10px;
    background-color: rgba(255, 153, 0, 0.322);
    margin: 0px 20px;
    padding: 10px 20px;
}

.box1 {
    background-color: rgba(255, 153, 0, 0.322) !important;
}

.box2 {
    background-color: rgba(255, 0, 0, 0.179) !important;
}

.box3 {
    background-color: rgba(0, 128, 0, 0.242) !important;
}

.box4 {
    background-color: #6498d069 !important;
}

.icon2 {
    background-color: rgba(255, 0, 0, 0.51) !important;
}

.icon3 {
    background-color: rgba(0, 128, 0, 0.455) !important;
}

.icon4 {
    background-color: #6498d0b4 !important;
}

.placeForIcon {
    background-color: rgba(255, 153, 0, 0.728);
    margin-top: 10px;
    width: 90px;
    height: 90px;
    justify-content: center;
    display: flex;
    align-items: center;
    border-radius: 10px;
    margin-right: 20px;
}

.iconica {
    margin-top: 5px;
    font-size: 50px;
    color: white;
}

.chart-wrapper {
    padding: 100px 0px;
    padding-bottom: 300px;
}

.chart-border {
    padding: 0px;
    border-radius: 10px;
    overflow: hidden;
}
</style>
